/**
 * static/js/utils/resize-observer.js
 *
 * Debounced ResizeObserver wrapper. Native ResizeObserver fires every animation
 * frame during a resize gesture; for scroll-recovery / layout-recompute use
 * cases we usually want a debounced trailing edge instead.
 *
 * Falls back to window resize/orientationchange listeners on browsers without
 * ResizeObserver.
 *
 * Loaded per-page (not in base.html). Pure utility — no auto-side-effects.
 *
 * Usage:
 *   const stop = JN.resizeObserver.observe(el, rect => {
 *     // recompute layout / scroll position
 *   }, 100);
 *   stop(); // disconnect when done
 *
 * Refs #3886 (Mobile UI/UX Phase 2 PR 2.1).
 */
(function (window) {
  'use strict';

  function debounce(fn, ms) {
    var timeout = null;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(timeout);
      timeout = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  function observe(element, callback, debounceMs) {
    var ms = debounceMs == null ? 100 : debounceMs;
    if (typeof window.ResizeObserver !== 'function') {
      // Fallback: window-level resize + orientationchange (less precise; element-specific
      // changes from sibling layout shifts won't fire — acceptable for the supported targets).
      var fb = debounce(function () { callback(element.getBoundingClientRect()); }, ms);
      window.addEventListener('resize', fb);
      window.addEventListener('orientationchange', fb);
      return function unobserve() {
        window.removeEventListener('resize', fb);
        window.removeEventListener('orientationchange', fb);
      };
    }
    var debounced = debounce(function (entries) {
      callback(entries[0].contentRect);
    }, ms);
    var ro = new ResizeObserver(debounced);
    ro.observe(element);
    return function unobserve() { ro.disconnect(); };
  }

  window.JN = window.JN || {};
  window.JN.resizeObserver = {
    observe: observe,
    debounce: debounce,
  };
})(window);
